module.exports = "<main-menu\n  ng-if=\"!$ctrl.isMobileApp && !$ctrl.employeeopplus\"\n  class=\"food-benefit\"\n  links=\"$ctrl.links\"\n>\n  <last-day-alert></last-day-alert>\n</main-menu>\n\n<main-menu-mobile\n  ng-if=\"$ctrl.isMobileApp && $ctrl.links && !$ctrl.employeeopplus\"\n  links=\"$ctrl.links\"\n  employee-info=\"$ctrl.employee\"\n  module=\"AA\"\n  manager-info=\"$ctrl.manager\"\n  show-links=\"true\"\n>\n</main-menu-mobile>\n\n<div ng-if=\"$ctrl.isLoaded\" ui-view></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/food-benefit.module/features/foodBenefitRouting/foodBenefitRouting.html
// module id = 1572
// module chunks = 0